import React, { useEffect } from "react";
import "./Header.css";
import { Link, useNavigate } from "react-router-dom";
import Message from "../animation/message/Message";
import Notification from "../animation/notification/Notification";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { GETAuthLogin, GetUserInfo } from "../../features/auth/Slice";

function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = async () => {
    Cookies.remove("driwe_admin_security");
    navigate("/login");
  };

  const user = useSelector((state) => state.auth?.user_info);

  useEffect(() => {
    dispatch(GetUserInfo());
  }, [dispatch]);

  return (
    <>
      <section className="header_main">
        <div className="container-fluid p-0">
          <div className="header_section theme_bg">
            <div className="row me-0 ms-0">
              <div className="col-sm-6 col-4">
                <div className="logo_div">
                  <Link to="/">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/assets/images/logo/logo2.png"
                      }
                      alt="logo"
                      className="logo_img"
                    />
                  </Link>
                </div>
              </div>
              <div className="col-sm-6 col-8">
                <div className="header_content">
                 

                  <div className="header_link me-4">
                    <div className="user_info">
                      <div className="">
                        <strong style={{ fontSize: "14px", color: "#333" }}>
                          Admin Wallet:{" "}
                          <span style={{ color: "#28a745" }}>
                            ₹ {user?.UserWallet?.amount}/-
                          </span>
                        </strong>
                      </div>
                      <div className="username " onClick={handleLogout}>
                        <p>
                          <FontAwesomeIcon icon={faRightFromBracket} />
                          &nbsp;&nbsp;Logout
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Header;
